<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Pengajuan Baru</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow class="float-right mb-2">
            <div class="search-list">
              <CCol sm="12">
                <CInput
                  class="float-left mb-0 mr-2"
                  placeholder="ID / Register Name"
                  v-model="request.q"
                  @input="onSearch()"
                >
                  <template #prepend-content>
                    <CIcon name="cil-magnifying-glass" />
                  </template>
                </CInput>
              </CCol>
            </div>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="100"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #sub_district="data">
              <td>
                <div class="button-table">
                  <a>{{ data.item.sub_district }}, {{ data.item.district }}</a>
                </div>
              </td>
            </template>
             <template #sla="data">
             <td>
              <div :style="{backgroundColor: data.item.sla.color}" class="sla-agent">
                {{data.item.sla.range}}
                </div>
             </td>
             </template>
            <template #action="data">
              <td>
              
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-1"
                    @click="detailClicked(data.item.agent_id)"
                    >Action</CButton
                  >
                  <CButton
                    color="warning"
                    class="mb-0"
                    @click="printData(data.item.agent_id)"
                    >Print</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="searchAgent('REFRESH')"
            >
              Refresh
            </div>
            <div class="pagination-btn-back" @click="searchAgent('BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ request.page }}</div>
            <div class="pagination-btn-next" @click="searchAgent('NEXT')">
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import jwt from "jsonwebtoken";
import AgentRegistrationUseCase from "./app/usecase/index.js";

export default {
  name: "NewRegistration",
  data() {
    return {
      items: [],
      fields: [
        { key: "agent_id", label: "ID" },
        { key: "register_name", label: "Nama Pendaftar" },
        { key: "sub_district", label: "Lokasi" },
        { key: "phone_number", label: "No HP" },
        { key: "registration_type", label: "Bentuk Pengajuan" },
        { key: "flag", label: "Status Pengajuan" },
        { key: "sla", label: "SLA" },
        { key: "created_at" },
        { key: "action", label: "Action" },
      ],
      request: {
        page: 1,
        per_page: 100,
        flag: "NEW,DRAFT",
        q:"",
      },
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
       debounce: {
        timeout: 0,
        duration: 5000,
      },
    };
  },
  mounted() {
    this.authentication();
    this.searchAgent();
  },
  beforeDestroy() {
    clearTimeout(this.debounce.timeout)
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    async searchAgent(action) {
     try {
        this.validatePagination(action);
        var queryString = Object.keys(this.request)
          .map((key) => key + "=" + this.request[key])
          .join("&");
        const { data, err } = await AgentRegistrationUseCase.getAll(queryString);
          if (err || data.length == 0) {
            this.validateNextPagination(action);
            this.err = err;
          }else {
          if (data) {
            window.scrollTo(0, 0);
            this.items = data;
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    validatePagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page + 1;
      } else if (action === "BACK") {
        if (this.request.page > 1) {
          this.request.page = this.request.page - 1;
        }
      } else if (action === "REFRESH") {
        this.request.page = 1;
      } else {
        this.request.page = 1;
      }
    },
    validateNextPagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page - 1;
      } else {
        this.items = [];
      }
    },
     onSearch() {
        setTimeout(this.searchAgent(), this.debounce.duration);
    },
    detailClicked(item) {
      this.$router.push({ path: `/agent/new-registration/${item}` });
    },
    editClicked(item) {
      this.$router.push({ path: `/agent/new-registration/edit/${item}` });
    },
    printData(item) {
      let route = this.$router.resolve({ path: `/print/${item}` });
      // let route = this.$router.resolve('/link/to/page'); // This also works.
      window.open(route.href, "_blank");
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    userCreate() {
      this.$router.push({ path: `/management/account/create` });
    },
  },
};
</script>

<style scoped>
@import url("./Agent.css");
</style>
